import * as React from "react";
import { FormItem } from "../../../../components/antd/form/FormItem";
import { FormItemValue } from "../../../../components/antd/form/FormItemValue";
import { FormLabel } from "../../../../components/antd/form/FormLabel";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

export const FileSystemTypeReadonly: React.FC = () => {
  const fileSystemType = useCpFormValue(`fileSystemType`);

  return (
    <FormItem lastItem>
      <FormLabel>File System Type</FormLabel>
      <FormItemValue>{fileSystemType}</FormItemValue>
    </FormItem>
  );
};
